import React from 'react'
import Header from './Header';
import Footer from './Footer';
import Page from './Page';
import CssBaseline from '@mui/material/CssBaseline';


class Basic extends React.Component{
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render(){
        const { page } = this.props;
        let bckg = ""
        if(page === "login" || page === "home"){
            bckg = "gradient-purple"
        }
        // console.log('=== BASIC LAYOUT PROPS =============');
        // console.log(this.props);
        // console.log('====================================');
        return(
            <div className={bckg}>
                <CssBaseline />
                <Header currentPage={page}/>
                    <Page>
                        {this.props.children}
                    </Page>
                <Footer {...this.props} />
            </div>
        )
    }
}

export default Basic;
